/**
 * Central types barrel.
 *
 * API-generated types live in src/types/api.d.ts (run `npm run types:generate`).
 * Frontend-only types live in src/types/tenant.ts and are re-exported here.
 */

export type { TenantTheme, TenantBrandingCache, ThemeOverride } from './tenant'

// ── Shared API envelope types ─────────────────────────────────────────────────

export interface PaginatedResponse<T> {
  success: boolean
  data: T[]
  meta: {
    total: number
    page: number
    per_page: number
    total_pages: number
  }
}

export interface ApiSuccessResponse<T> {
  success: true
  data: T
  meta?: Record<string, unknown>
}

/** Normalised error thrown by the Axios response interceptor */
export class ApiError extends Error {
  readonly code: string
  readonly httpStatus?: number
  /** Extra data payload from the error response body (e.g. conflict details) */
  readonly data?: unknown
  constructor(code: string, message: string, httpStatus?: number, data?: unknown) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.httpStatus = httpStatus
    this.data = data
  }
}

// ── Permission map (built from PermissionSet[] in auth store) ─────────────────

export type PermissionMap = Record<
  string,
  { canRead: boolean; canCreate: boolean; canUpdate: boolean; canDelete: boolean }
>
